export default "__VITE_ASSET__CqeatR3$__"